import { getLayoutByIdApi, LayoutResponseType } from '@app-store'
import { useEffect, useState } from 'react'
import {
  getEntityData,
  getEntityDataByIdEntityNameEmbedded,
} from '../../apis/entityData.api'
import { FieldValues } from 'react-hook-form'
import FormRenderer from '../FormRenderer'
import { EntityLayout, LayoutData } from '../../types/layout.types'
import { MODE_CONSTANTS } from '@ui-kit'
import { noop } from 'lodash'
import { PatientInsuranceInfoPropsType } from '../../types/pap.types'

const PatientInsuranceInfo = ({
  task,
  recordId,
}: PatientInsuranceInfoPropsType) => {
  const [listingLayout, setListingLayout] = useState<LayoutResponseType>()
  const [insuranceData, setInsuranceData] = useState<FieldValues>()

  const fetchPatientId = async () => {
    try {
      const res = await getEntityDataByIdEntityNameEmbedded(
        task?.identifier?.layout_info?.case?.entity_name ?? '',
        ['patient'],
        recordId
      )
      if (res.data) {
        fetchInsuranceData(res?.data?.patient?.id)
      }
    } catch (err) {
      console.error(err)
    }
  }

  const fetchListingLayout = async () => {
    try {
      const res = await getLayoutByIdApi({
        entityId: task?.identifier?.layout_info?.insuranceLayout?.entity_id,
        layoutId: task?.identifier?.layout_info?.insuranceLayout?.layout_id,
      })
      if (res.data) {
        setListingLayout(res.data)
        fetchPatientId()
      }
    } catch (err) {
      console.error(err)
    }
  }

  const fetchInsuranceData = async (patientId: string) => {
    try {
      const res = await getEntityData(
        task?.identifier?.layout_info?.insuranceLayout?.entity_name ?? '',
        Number(task?.identifier?.layout_info?.insuranceLayout?.entity_id),
        Number(task?.identifier?.layout_info?.insuranceLayout?.layout_id),
        patientId
      )
      if (res.data) {
        setInsuranceData(res.data)
      }
    } catch (err) {
      console.error(err)
    }
  }

  useEffect(() => {
    fetchListingLayout()
  }, [])

  return (
    <FormRenderer
      layout={listingLayout?.layout_data as LayoutData}
      mode={MODE_CONSTANTS?.EDIT}
      data={insuranceData}
      handleFormSubmit={noop}
      fullLayout={listingLayout as EntityLayout}
      heading={null}
    />
  )
}

export default PatientInsuranceInfo
